export const BG = {
  preparing_zip: "Подготовка на zip…",
  compressing: "Компресиране…",
  info_icon: "След като бъде маркирано като завършено, не могат да се присъединяват или да бъдат добавени допълнителни членове и всички чат групи ще бъдат деактивирани. Моля, имайте предвид, че проектът, заедно с всички чат групи и данни, ще остане достъпен в деактивирано състояние.",
  mark_is_done: "Сигурни ли сте, че искате да маркирате проекта като завършен? След маркиране, не могат да се присъединяват или да бъдат добавени допълнителни членове и всички чат групи ще бъдат деактивирани. Моля, имайте предвид, че проектът, заедно с всички чат групи и данни, ще остане достъпен в деактивирано състояние.",
  mark_not_done: "Сигурни ли сте, че искате отново да отворите проекта? След маркиране като отворен, допълнителни членове могат да се присъединят или да бъдат добавени и всички чат групи ще бъдат реактивирани.",
  mark_as_completed: "Маркирай проект като завършен",
  room_completed: "Проект завършен",
  room_members: "Членове на проекта",
  deactivated_rooms: "Деактивирани проекти",
  deactivated_chats: "Деактивирани чатове",
  completed_rooms: "Завършени проекти",
  request_to_join_a_room: 'Заявка за присъединяване към проекта',
  wants_to_rejoin_room: 'Username иска да се присъедини отново към проекта Roomname.',
  invited_you_to_join_room: 'Username ви покани да се присъедините към проекта Roomname.',
  restart: "Рестарт",
  update_text: "Налично е нова актуализация. Щракнете върху рестарт, за да инсталирате актуализацията.",
  update_availble: "Налична актуализация",
  Loading: "Зареждане...",
  logout: "Излизане",
  back: 'Назад',
  company_list: "Списък с компании",
  followers: "Последователи",
  followings: "Следвания",
  article: "Статия",
  companies: "Компании",
  one_to_one_chat: " Чат един на един",
  profile: "Профил",
  company: "Компания",
  company_selection: "Избор на компания",
  home: "Начало",
  contact: "Контакт ",
  add_company: "Добави компания ",
  add_project: "Добави проект ",
  capacities: "Капацитети ",
  work_area: "Работна зона",
  company_services: "Услуги на компанията",
  website: "Уебсайт",
  search_contacts: "Търсене на контакти",
  add_or_join_a_company: "Добави или се присъедини към компания",
  follow: "Следвай",
  following: "Следване",
  like: "Харесай",
  company_contacts: "Контакт на компанията",
  leave_the_company: "Напусни компанията",
  news: "Новини",
  earlier: "По-рано",
  action: "Действие",
  another_action: "Друго действие",
  something_else: "Нещо друго",
  search: "Търсене",
  search_rooms: "Търсене на проекти",
  search_articles: "Търсене на статии",
  contacts: "Контакти",
  suggestions: "Предложения",
  project_list: "Списък с проекти",
  search_results: "Резултати от търсенето",
  add_or_join_project: "Добави или се присъедини към проект",
  details: "Детайли",
  your_position_within_company:
    "Моля, изберете вашата позиция в компанията.",
  close_modal: "Затвори",
  map: "Карта",
  or: "Или",
  name: "Име*",
  street: "Улица*",
  house_number: "Номер на къща",
  postal_code: "Пощенски код",
  city: "Град*",
  opened_by: "Отворено от:",
  project_No: "Номер на проект: ",
  building_type: "Тип сграда*",
  building_types: "Тип сграда",
  add_join: "Добави/Присъедини се",
  mandatory_fiels: "*задължителни полета",
  invalid_fiels: "Това поле е задължително",
  add_or_join_company: "Добави или се присъедини към компания",
  name_of_the_company: "Име на компанията",
  edit_company_details: "Редактирай данни на компанията",
  branch_of_the_building_industry: "Отрасъл на строителната индустрия",
  corporate_form: "Корпоративна форма",
  position_within_company: "Позиция в компанията",
  request_confirmation: "Изчакващи заявки за проекти",
  company_e_mail: "E-mail на компанията",
  type_of_filter: "Въведете за филтриране...",
  setting: "Настройка",
  dashboard: "Табло",
  settings: "Настройки",
  views: "Прегледи",
  times_seen: "пъти прегледано",
  see_more: "...още",
  see_less: "...по-малко",
  in_search: "в търсенето",
  reset_password: "Нулиране на парола",
  submit: "Изпрати",
  password: "Парола",
  email: "E-mail",
  confirm_password: "Потвърди парола",
  reset_email: "Нулиране на e-mail",
  update: "Актуализация",
  new_email: "Нов e-mail",
  kjuup_message: "Kjuup Съобщение",
  delete_profile: "Изтриване на профил?",
  my_position: "Моята позиция:",
  add: "добави",
  owner_company_admin: "Администратор на компания :",
  owner_company_admin_new: "Администратор на компания",
  mutual_contact: "общ контакт",
  mutual_contacts: "общи контакти",
  co_owner: "Съсобственик",
  managing_director: "Изпълнителен директор",
  associate: "Съдружник",
  secretary: "Секретар",
  employee: "Служител",
  project_manage: "Проектен мениджър",
  auto_chat_translation: "Автоматично превеждане на чат",
  translate_room_group_names: "Превод на имена на чат групи",
  translate_room_group_names_info: "Когато е включено, имената на чат групите се превеждат автоматично на езика на интерфейса.",
  default_view_email: "Default View: E-Mail",
  default_view_email_info: "Когато е активирано, разделът E-Mail ще се отваря по подразбиране вместо Съобщения при отваряне на приложението.",
  integrate_email_in_messages: "Integrate E-Mail in Messages",
  integrate_email_in_messages_info: "When enabled, emails from all connected accounts will appear alongside your chat messages, sorted by date.",
  language: "Език",
  english: "Английски",
  german: "Немски",
  french: "Френски",
  italian: "Италиански",
  change_language: "Промяна на езика",
  my_companies: "Моите компании",
  employees: "Служители",
  invite_with_a: "Поканете към Kjuup",
  add_member: "Добави член",
  add_user: "Добави потребител",
  send_location: "Изпрати местоположение",
  assign_admin_rights: "Регулирай администраторско право",
  deactivate_company: "Деактивирай компания",
  remove_employees: "Премахни служители",
  remove_members: "Премахни членове",
  no_user_found: "Потребител не е намерен!",
  approve: "Одобри!",
  deselect_all: "Отмени избор на всички",
  select_all: "Избери всички",
  translation_on_building_projects: "Превод в проекти",
  reported_capacities: "Докладвани услуги",
  up_to_50m_exact: "До 50м точно",
  company_details_service: "Услуги на компанията",
  company_contact: "Контакт на компанията",
  invite_with_link: "Поканете към Kjuup",
  share_link: "Сподели връзка",
  share_company_link: "Сподели връзка",
  qr_code: "QR код",
  copy_link: "Копирай връзка",
  cancel_link: "Отмени връзка",
  who_has_confirmed_services: "Кой е потвърдил вашите услуги?",
  projectss: "Проекти",
  add_services: "Добави услуги",
  services: "Услуги",
  save_text: "Запази",
  share_on: "Сподели в:",
  articlen: "Статия",
  invite_user_to_confirm_service:
    "Поканете потребители да потвърдят услуги към компанията.",
  link_copied: "Връзката е копирана!",
  email_copied: "E-mail е копиран!",
  personal_article: "Лична статия",
  company_article: "Статия на компанията",
  characters_remaining: "Оставащи символи",
  optional_information: "Незадължителна информация",
  project: "Проект",
  projects: "Проекти...",
  abort: "Отхвърли",
  preview: "Преглед",
  post: "Публикувай",
  of: "от",
  remove: "Премахни",
  free_capacity: "Портал за работа",
  current_status_overview: "Преглед на текущото състояние",
  report_capacities: "Докладвай услуги",
  report_text: "Доклад",
  search_capacities: "Намери изпълнители",
  add_project_user: "Добави потребител на проект",
  media: "Медия",
  links: "Връзки",
  docs: "Документи",
  featured_products: "Препоръчани продукти...",
  title: "Заглавие",
  text: "Текст",
  feed_details: "Детайли на лента",
  add_employee: "Добави служител",
  latest: "Най-нови",
  my_projects: "Моите проекти",
  cancel: "Отмени",
  continue: "Продължи",
  role_in_the_building_industry: "Роля в строителната индустрия",
  als: "като",
  join: "присъедини се",
  find: "Намери",
  request_to_join_a_company: "Заявка за присъединяване към компанията",
  wants_to_join_the_company: "иска да се присъедини към компанията",
  filter_by: "Филтрирай по",
  ok: "Ок",
  close: "Затвори",
  weekly_statistics: "Седмична статистика",
  is_following_you: "ви следва.",
  as: "като",
  has_joined_the: "се присъедини към компанията",
  has_looked_at_your_profile: "погледна вашия профил.",
  time: "Час",
  in_searches_in_past_week: "в търсенията миналата седмица.",
  has_liked_your_article: "хареса вашата статия.",
  has_published_a_new_article: "публикува нова статия.",
  you: "Вие",
  all_views: "Всички прегледи",
  all_profile_views: "Всички прегледи на профила",
  mutual_company: "обща компания",
  artical_text: "Напиши статия...",
  you_have_appeared: "Появихте се",
  your_request_at_the_company: "Вашата заявка в компанията",
  times_you_have_appeared_in_searches: "пъти сте се появили в търсенията",
  appear_more_often_in_searches: "Появявайте се по-често в търсенията",
  you_have_been_found: "Бяхте намерени",
  improve_profile: "Подобри профила",
  choose_existing_contact_for_single_chat:
    "Изберете съществуващ контакт за единичен чат:",
  in_order_to_add_new_contacts:
    "За да добавите нови контакти, моля, търсете нови контакти на страницата на профила.",
  times_in_searches_in_the_last_week:
    "пъти в търсенията миналата седмица. Актуализирайте вашия профил и добавете допълнителни детайли, за да бъдете намерени по-лесно.",
  has_been_confirmed: "е потвърдено.",
  have_joined_the: "се присъединиха към  ",
  building_project: " строителен проект.",
  select_with_which_company_you_want_to_connect_to_the_project:
    "Изберете компанията, която ще представлявате. Това ще бъде показано на другите участници.",
  select_with_which_company_you_want_to_connect_to_the_chat:
    "Изберете компанията, която ще представлявате. Това ще бъде показано на другите участници.",
  select_internal_section: "Моля, изберете вътрешен раздел",
  select_profile_image: "Избери изображение на профила",
  share_user: "Сподели потребител",
  contact_sender_message:
    "Споделете тази връзка, за да поканете не-член на Kjuup към Kjuup. Тази връзка може да се използва от множество хора за регистрация.",
  project_sender_message:
    "Споделете тази връзка, за да поканете не-член на Kjuup към проекта име на проект. Тази връзка може да се използва от множество хора за регистрация и присъединяване към проекта име на проект в Kjuup.",
  company_sender_message:
    "Споделете тази връзка, за да поканете не-член на Kjuup към компанията име на компания. Тази връзка може да се използва от множество хора за регистрация и присъединяване към компанията в Kjuup.",
  contact_receivers_message:
    "Връзка за покана за присъединяване към Kjuup. Моля, щракнете върху връзката, за да се регистрирате в kjuup.",
  iphone: "iPhone:",
  iphone_recivers_message:
    "В случай, че инсталирате Kjuup чрез Apple App Store, трябва да щракнете върху тази връзка след успешно изтегляне, за да можете да се регистрирате.",
  project_receivers_message:
    "Връзка за покана за присъединяване към проекта име на проект в Kjuup. Моля, щракнете върху връзката, за да се регистрирате в Kjuup и да се присъедините към проекта име на проект.",
  company_receivers_message:
    "Връзка за покана към компанията име на компания в Kjuup. Моля, щракнете върху връзката, за да се регистрирате в Kjuup и да се присъедините към компанията име на компания.",
  sign_in: "Вход",
  enter_your_email_add: "Въведете вашия e-mail адрес",
  forgot_password: "Забравена парола",
  dont_have_account: "Нямате акаунт?",
  register: "Регистрация",
  get_app: "Изтегли приложението",
  registration: "Регистрация",
  dep_ing: "Dipl.-Ing.",
  dr: "Д-р",
  dr_ing: "Д-р инж.",
  dep_ing_arc: "Dipl.-Ing. Архитект",
  prof: "Проф.",
  first_name: "Собствено име",
  last_name: "Фамилия",
  have_an_account: "Имате акаунт?",
  when_register_you_agree: "При регистрация се съгласявате с нашите",
  term_of_use: "условия за използване",
  to: ".",
  in_our: "В нашата",
  data_policy: "политика за данни",
  they_find_out: "ще разберете,",
  we_provide_store_data: "как събираме, обработваме и съхраняваме информация.",
  leaving_company_text:
    "Наистина ли искате да напуснете компанията? Когато напуснете компанията, вие също напускате всички свързани проекти и чат групи. Можете да се присъедините отново към тези проекти с друга компания по всяко време.",
  delete_profile_text:
    "Наистина ли искате да изтриете вашия профил? Когато изтриете вашия профил, всички връзки с компании, проекти и чатове ще бъдат премахнати. Можете да създадете нов профил по всяко време.",
  confirm: "Потвърди",
  reject: "Отхвърли",
  requet_to_leave: "Заявка за напускане",
  choose: "Избери",
  your_add_member: "Добави член",
  if_you: "в случай, че",
  can_not_find: "не можете да намерите вашия контакт тук.",
  please_wait: "Моля, изчакайте..",
  imprint_gtc: "Отпечатък/ОБУ",
  register_confirm_popup: "Потвърдете имейла си в Kjuup преди вход. Изпратихме връзка за потвърждение. Ако не я виждате, проверете и папката за спам.",
  PENDING_GROUP_USER:
    "ще получава съобщения само след като поканата към проекта бъде потвърдена. Допълнително съобщение ще се появи, след като поканата към проекта бъде потвърдена.",
  PENDING: "Потвърждаване на поканата към проекта в изчакване",
  denied_group_chat: " отхвърли поканата за проекта и напусна тази група.",
  // joined_group_chat: " се присъедини към стаята и тази група.",
  joined_group_chat: " се присъедини към тази група",
  you_joined_group_chat: "Вие се присъединихте към тази група.",
  Others: "Други",
  LEFT_GROUP: "напусна тази чат група.",
  YOU_LEFT_GROUP: "напуснахте тази чат група.",
  days: "дни",
  day: "ден",
  hour: "час",
  hide_project: "Скрий проект",
  hide_project_popup_text:
    "Ако скриете проекти, те не могат да бъдат намерени в Kjuup. Само членовете на проекта могат да поканят нови потребители към проекта.",
  branch: "Отрасъл",
  photo_video_media_lib: "Медийна библиотека - Снимки и видео",
  document: "Документ",
  location_meeting: "Местоположение / Среща",
  all_member_of_project: "Всички членове на проекта",
  pending_request: "Изчакващи заявки за проекти",
  no_pending_request: "Не са намерени изчакващи заявки!",
  news_feed: "Лента с новини",
  user_info: "Информация за групата",
  leave_project: "Напусни проект",
  media_link_docs: "Файлове",
  search_chat: "Търсене в чат",
  export_chat_group: "Експортирай данни на чат група от миналия месец",
  request_complete_chat_history: "Заяви пълна история на чата",
  leave_chat_group: "Напусни чат група",
  add_user_project: "Добави потребител",
  me: "Аз",
  max_open_one_to_one:
    "В момента могат да се отворят макс. 2 чата един на един успоредно в долния и горния раздел. Общо макс. 4 чата един на един са възможни.",
  are_you_sure_you_want_leave_chat:
    "Сигурни ли сте, че искате да напуснете тази чат група?",
  create_group: "Създай група",
  adding_members: "Добавяне на членове...",
  creating_the_chat: "Създаване на чат...",
  finishing_setup: "Завършване...",
  group_name: "Име на групата",
  by: "От:",
  mandetory: "*задължително",
  delteed: "изтри своя профил и напусна груповия чат.",
  deleted_direct: "изтри своя профил и напусна чата.",
  unhidden_message:
    "Ако не скриете проекти, те могат да бъдат намерени от всички членове на Kjuup.",
  account_deleted: "Акаунтът е изтрит.",
  refuse_company: "Сигурни ли сте, че искате да отхвърлите поканата на компанията?",
  follow_additional: "Следвай допълнителни потребители",
  f_add:
    "Следвайте допълнителни потребители на Kjuup, за да ги направите достъпни за директни съобщения.",
  c_inv: "Покана(и) от компания",
  invited_o_Company: "Поканени сте да се присъедините към компанията",
  refuse_companyX: "Сигурни ли сте, че искате да отхвърлите заявката на компанията?",
  a_Da: "Акаунтът е деактивиран.",
  has_deactivated: "деактивира своя профил.",
  reactive: "реактивира своя профил.",
  juup_note: "*Регистрация с потребителско име налична само за членове на Kjuup+",
  username: "Потребителско име*",
  email_username: "E-mail/Потребителско име*",
  sPinText:
    "Моля, предоставете 6-цифрен PIN код за сигурност. Този PIN код ще е необходим, ако забравите вашата парола и е задължителен за потвърждаване на вашия акаунт.",
  DeleteKjuupPlusText:
    "Наистина ли искате да изтриете вашия профил? Когато изтриете вашия профил, всички връзки с компании, проекти и чатове ще бъдат премахнати.\n\nВ рамките на 48 часа след изтриване на акаунта можете да реактивирате вашия акаунт, като влезете с потребителско име, парола и PIN код.",
  reactive_text:
    "Вашият акаунт е изтрит. Моля, щракнете върху Реактивирай, за да реактивирате вашия акаунт.",
  rac: "Реактивирай",
  ac_ss: "Акаунтът е реактивиран успешно.",
  not_valid_pin: "PIN кодът е невалиден",
  only_for_kjuup:
    "*Нулиране на парола чрез потребителско име и PIN код налично само за членове на Kjuup+.",
  resetPIN: "Нулирай PIN код",
  enter_current_pin: "Моля, въведете вашия текущ PIN код",
  enter_new: "Въведете нов PIN код",
  pin_to_confirm: "Моля, предоставете PIN кода за потвърждение.",
  change_username: "Нулирай потребителско име",
  pp_not_match: "Паролата и потвърждението на паролата не съвпадат",
  reactive_itself: "Реактивирахте вашия профил.",
  has_deactivated_itself: "Деактивирахте вашия профил.",
  more_than_two:
    "В момента директните съобщения могат да се правят само с 2 потребителя успоредно.",
  Chats: "Директни съобщения",
  only_in_mobileL:
    "Нативните видео в момента могат да се качват и публикуват само чрез мобилното приложение. Моля, използвайте видео връзки от Youtube и Vimeo.",
  register_pin_text:
    "Моля, изберете вашия личен 6-цифрен PIN код. Този PIN код ще е необходим за активиране на функционалности за нулиране на акаунт.",
  internal_project: "Вътрешен",
  external_projects: "Външен",
  in_deacticted: "Вътрешният раздел е деактивиран.",
  create_article: "Създай статия",
  new_article_selection: "Създай статия за външна лента с новини",
  new_article_selection_internal: "Създай вътрешна статия",
  active_trans_title: "Включване на автоматичен превод?",
  active_trans: "Когато е включен, всички входящи съобщения в чата ще бъдат преведени на избрания от вас език на приложението.",
  disable_trans: "Наистина ли искате да деактивирате автоматично превеждане?",
  allow_access_chat: "Покажи пълна история на чата",
  toggle_chat_history_on:
    "Наистина ли искате потребителят да вижда пълната история на чата?",
  toggle_chat_history_off:
    "Наистина ли искате потребителят да вижда само историята на чата от момента на присъединяване към чата?",
  check_selected_settings:
    "Моля, проверете настройките за история на чата за всички избрани потребители!",
  chat_from_start_have:
    "Вие се присъединихте към тази група. Историята на чата е споделена.",
  chat_from_start_has:
    "се присъедини към тази група. Историята на чата е споделена.",
  Address: "Адрес",
  read_by: "Прочетено от",
  deliver_to: "Доставено до",
  remaining: "остава",
  message_info: "Информация за съобщението",
  request_to_join_only: "Заявка за присъединяване",
  unfollow: "Спрете да следвате",
  company_username: "Потребителско име",
  month: [
    "Яну",
    "Фев",
    "Мар",
    "Апр",
    "Май",
    "Юни",
    "Юли",
    "Авг",
    "Сеп",
    "Окт",
    "Ное",
    "Дек",
  ],
  remove_my_admin_right: "Премахни моите администраторски права",
  makeEmp: "Наистина ли искате да премахнете администраторските права на компанията от потребителя?",
  remove_my_self:
    "Наистина ли искате да премахнете администраторските права на компанията от вашия акаунт?",
  makeAdmin: "Наистина ли искате да предоставите на потребителя администраторски права на компанията?",
  remove_member: "Премахни член",
  remove_following_confirm: "Наистина ли искате да премахнете {name} от списъка с последвани?",
  remove_follower_confirm: "Наистина ли искате да премахнете {name} от вашите последователи? Ако го/я премахнете, няма да бъде информиран/а.",
  do_you_really_want_to_remove:
    "Наистина ли искате да премахнете потребителското име от компанията?",
  invite_all: "Поканете всички членове на компанията",
  invite_all_members: "Поканете всички членове",
  mems: "Всички други членове",
  dep_loc: "Отдел/Местоположение/Екип",
  depAdmin: "Администратор на отдел",
  add_remove_admin: "Добави/Премахни позиция администратор на компания",
  add_remove_dep_admin: "Добави/Премахни позиция администратор на отдел",
  remove_employees_dept: "Премахни служители от",
  want_to_join_dep:
    "Потребителско име иска да се присъедини към Отдела/Местоположението/Екипа depname на компанията companyname.",
  you_invited:
    "Поканени сте да се присъедините към Отдела/Местоположението/Екипа depname на компанията companyname.",
  dep_remove:
    "Наистина ли искате да премахнете администраторски права за отдел или местоположение от потребителя?",
  add_dep:
    "Наистина ли искате да предоставите на потребителя администраторски права за отдела или местоположението?",
  my_self_dep_remove:
    "Наистина ли искате да премахнете администраторски права на отдел от вашия акаунт?",
  member: "Член",
  admin: "Администратор",
  remove_project_admin:
    "Наистина ли искате да премахнете члена от проекта?",
  remove_my_self_project: "Наистина ли искате да премахнете администраторски права?",
  remove_member_admin_right:
    "Наистина ли искате да премахнете администраторски права от потребителя?",
  add_member_admin_right: "Наистина ли искате да добавите администраторски права към потребителя?",
  add_remove_Poss: "Добави/Премахни позиция администратор",
  forward: "Препрати",
  edit: "Редактирай",
  only_kjuup_plus_can: "Само компании Kjuup+ могат да публикуват статии.",
  add_images: "Добави изображение(я)",
  request_confirmation: 'Изчакващи покани за проекти',
  Activity: "Активност",
  latest_messages: "Последни съобщения",
  hours: "часа",
  minute: "минути",
  seconds: "секунди",
  days: "дни",
  yesterday: "вчера",
  last_week: "миналата седмица",
  next_week: "следващата седмица",
  Last_month: "миналия месец",
  All: "Всички",
  register_plus: "Регистрация Плюс",
  select_files: "Избери файлове",
  monthsFullName: [
    "Януари",
    "Февруари",
    "Март",
    "Април",
    "Май",
    "Юни",
    "Юли",
    "Август",
    "Септември",
    "Октомври",
    "Ноември",
    "Декември",
  ],
  company_deploc_receivers_message:
    "Връзка за покана към отдела на компанията име на компания в Kjuup. Моля, щракнете върху връзката, за да се регистрирате в Kjuup и да се присъедините към компанията име на компания.",
  no_news: "Няма налични новини",
  reminder: "Напомняне",
  np_reminder: "Няма задачи",
  move_to_reminder: "Премести към задача",
  remove_reminder: "Наистина ли искате да премахнете това съобщение от списъка с вашите задачи?",
  remove_all_reminder: "Премахни всички задачи",
  remove_all_confirm: "Наистина ли искате да премахнете всички съобщения от списъка с вашите задачи?",
  remove_from_reminder: "Премахни от напомняне",
  prevent_email: "E-mail не може да се използва като Потребителско име.",
  allow_noti: "Моля, разрешете известия.",
  join_cap: "Присъедини се",
  pass_minimum:
    "**Паролата изисква 12 символа, включително малка буква, главна буква, цифра и специален символ.",
  pass_error: "Моля, проверете изискванията за парола",
  people_that_like_article: "Хора, които харесват статията.",
  people_who_like_article: "Хора, които харесват вашата статия.",
  message_delete: "Това съобщение е изтрито.",
  message_edited: "редактирано",
  edit_message: "Редактиране на съобщението",
  edit_window_expired: "Съобщенията могат да се редактират само до 10 минути след изпращане.",
  message_edit_save: "Запази",
  copy: "Копирай",
  bookmark: "Отметка",
  add_reaction: "Добави реакция",
  delete_message: "Изтрий съобщението",
  more_options: "Още опции",
  info: "Инфо",
  link_invite: "Поканете чрез връзка",
  ll_nkk: "Поканете към Kjuup",
  selected: "Избрано",
  is_active: "Активен",
  inactive: "Неактивен",
  last_online: "последно онлайн {{when}}",
  remove_user_l: "Премахни",
  link_expire: "Всяка генерирана връзка ще бъде валидна за 72 часа.",
  company_language: "Език на компанията",
  company_language_info:
    "Изборът на език ще се използва за всички потвърждения по e-mail, свързани с компанията.",
  s_image: "изображение",
  m_image: "изображения",
  removeMsg: "Натиснете за премахване",
  block: 'Блокирай',
  unblock: 'Отблокирай',
  blocks: 'Сигурни ли сте, че искате да блокирате този потребител?',
  unblocks: 'Сигурни ли сте, че искате да отблокирате този потребител?',
  bolcked_click_un_block:
    'Блокирали сте този контакт. Щракнете тук, за да премахнете блокирането.',
  you_have_unblocked: 'Отблокирали сте този контакт.',
  you_have_blocked: 'Блокирали сте този контакт.',
  unblock_to_send: 'Отблокирай потребител, за да изпратиш съобщение.',
  pilot_text: "Специализиран AI за строителни теми",
  startup_screen_label: "Начален екран",
  startup_screen_info: "Изберете кой екран се отваря при стартиране на Kjuup.",
  startup_screen_feed: "Home",
  startup_screen_messages: "Съобщения",
  startup_screen_saved: "Началният екран е обновен",
email_on: "E-mail известия за чатове",
  email_on_grp: "E-mail известие",
  article_email_on: "Email notification articles",
  article_email_info: "If you enable email notifications for internal articles, you will receive an email when a new internal article is published in your company and department.",
  info_email_room: "Активирайте или деактивирайте e-mail известия за този проект. Тази опция е налична само когато \"E-mail известия за чатове\" е активирана чрез лични настройки.",
  todo_notification_info: "Ще получавате известие всеки път, когато ви бъде възложена нова задача.",
  info_val: "Ще получите имейл, ако ново съобщение в чата не бъде прочетено в кратък срок. Можете да го изключите за конкретни проекти или чатове в техните настройки или в информацията за чат групата.",
  email_groups: "Активирайте или деактивирайте e-mail известия за този чат. Тази опция е налична само когато \"E-mail известия за чатове\" е активирана чрез лични и настройки на проекта.",
  add_update_email: "Добави/Актуализирай e-mail",
  text_to_verifiy: "Опцията \"E-mail известия за чатове\" може да се активира само ако имате потвърден e-mail адрес във файла.",
  stored_email: "Запазен e-mail: ",
  verify_email: "Потвърждаване в изчакване!",
  join_call:"Присъедини се",
  call_is_started:"Обаждането е започнало",
  start_chat:"Започни директно чат?",
  project_rooms:"Проекти",
  download_selected:"Изтегли",
  add_employee_confirm: 'Сигурни ли сте, че искате да добавите този потребител към компанията?',
  invalid_deeplink: "Невалиден URL на дълбока връзка. Липсват задължителни параметри.",
  deeplink_error: "Не може да се обработи дълбоката връзка. Моля, опитайте отново по-късно.",
  // Reply functionality translations
  reply: "Отговор",
  reply_enter: "Въведете отговор...",
  reply_sent_successfully: "Отговорът е изпратен успешно",
  reply_failed: "Неуспешно изпращане на отговор",
  reply_failed_generic: "Неуспешно изпращане на отговор. Моля, опитайте отново.",
  replying_to_message: "Отговаряне на съобщение",
  cancel_reply: "Отмени отговор",
  voice_message: "Гласово съобщение",
  send: "Изпрати",
  cancel: "Отмени",
  type_your_reply: "Напишете вашия отговор...",
  
  // Auto-suggestion translations
  suggested_replies: "Предложени отговори",
  suggestions_error: "Неуспешно зареждане на предложения",
  positive_suggestion_placeholder: "Positive",
  neutral_suggestion_placeholder: "Neutral",
  negative_suggestion_placeholder: "Negative",
  lazy_media_image: "Image — Click to load",
  lazy_media_audio: "Voice message — Click to load",
  lazy_media_doc: "Document — Click to load",
  lazy_media_video: "Video — Click to load",
  suggestion_loading_message: "Момент. Вашият текст се подготвя индивидуално за вас.",
  loading_chat_message: "Зареждане на чат...",
  
  // Manual ToDo translations
  extracting_message: "Извличане на съобщение...",
  create_todo: "Създай задача",
  create_todo_confirmation: "Искате ли да създадете задача от това съобщение?",
  select_project_required: "Моля, изберете проект/група",
  only_assigned_can_change_status: "Само назначените потребители могат да променят статуса",
  todo_summary: "Резюме",
  todo_summary_placeholder: "Въведете резюме на задачата...",
  todo_date: "Дата",
  todo_time: "Час",
  todo_date_hint: "Оставете празно, за да използвате датата/часа на оригиналното съобщение",
  todo_created_success: "Задачата е създадена успешно",
  todo_creation_failed: "Неуспешно създаване на задача",
  create: "Създай",
  
  image: "изображение",
  images: "изображения",
  remove_all_images: "Премахни всички изображения",
  remove_image: "Премахни изображение",
  remove_document: "Премахни документ",
  remove_recording: "Премахни запис",
  play_recording: "Възпроизведи запис",
  upload_image: "Качи изображение",
  upload_document: "Качи документ",
  record_audio: "Запиши аудио",
  stop_recording: "Спри записа",
  stop_recording_text: "Спри записа",
  please_remove_current_attachment: "Моля, премахнете текущото прикачено файл за",
  please_upload_image_file: "Моля, качете валиден файл с изображение",
  please_upload_valid_document: "Моля, качете валиден файл с документ",
  searching_messages: "Търсене на съобщения...",
  loading_more: "Зареждане на още...",
  loading_more_users: "Зареждане на още потребители...",
  load_more_users: "Зареди още потребители",
  no_more_users_to_load: "Няма повече потребители за зареждане",
  no_messages_found: "Не са намерени съобщения",
  try_different_keyword: "Опитайте различна ключова дума или проверете правописа си.",
  search_messages: "Търсене на съобщения, групи за чат, проекти и потребители...",
  todo: "Задача",
  np_todo: "Няма задачи",
  move_to_todo: "Запази като задача",
  remove_todo: "Наистина ли искате да премахнете задачата?",
  remove_all_todo: "Премахни всички задачи",
  remove_all_todo_confirm: "Наистина ли искате да премахнете всички задачи?",
  add_to_todo: "Добави към задача",
  remove_from_todo: "Премахни от задача",
  confirm: "Потвърди",
  ok: "Ок",
  read_more: "Прочети още",
  show_less: "Покажи по-малко",
  show_more: "Покажи повече",
  audio: "Аудио",
  video: "Видео",
  // Notification Settings
  notification_schedule: "График на известията",
  notification_schedule_desc: "Ще получавате push и имейл известия само в часовете, които изберете. Извън тези времена ще бъдат спрени.",
  learn_more: "Научете повече",
  allow_notifications: "Разреши известия:",
  every_day: "Всеки ден",
  weekdays: "Работни дни (понеделник до петък)",
  custom: "Персонализирано",
  monday: "Понеделник",
  tuesday: "Вторник",
  wednesday: "Сряда",
  thursday: "Четвъртък",
  friday: "Петък",
  saturday: "Събота",
  sunday: "Неделя",
  to: "до",
  notification_settings: "Известия",
  notification_settings_saved: "Настройките за известия са запазени успешно",
  notification_settings_error: "Неуспешно запазване на настройките за известия",
  unavailability_note: "Бележка за отсъствие",
  unavailability_description: "Задайте бележка за отсъствие. Докато е активна, бележката се показва на другите във всичките ви чатове и известията са на пауза.",
  unavailability_start_date: "Начална дата",
  unavailability_end_date: "Крайна дата",
  unavailability_message: "Съобщение",
  unavailability_message_hint: "Използвайте {endDate} като заместител за датата на връщане.",
  unavailability_replacement: "Заместващ контакт",
  unavailability_replacement_placeholder: "Въведете потребителски идентификатор за спешни заявки",
  unavailability_replacement_current: "Текущ заместник",
  unavailability_replacement_hint: "Ако е зададено, в бележката за отсъствие ще се покаже линк за връзка с това лице за спешни въпроси.",
  unavailability_replacement_none: "Без заместник (по избор)",
  unavailability_contact_urgent: "За спешни заявки се свържете с",
  unavailability_default_message: "В момента не съм в офиса и нямам достъп до Kjuup. Ще бъда отново на разположение от {endDate} и ще се свържа с вас тогава.",
  unavailability_save: "Запази",
  unavailability_deactivate: "Деактивирай",
  unavailability_active_until: "Активно до",
  unavailability_saved: "Бележката за отсъствие е запазена",
  unavailability_save_error: "Неуспешно запазване на бележката за отсъствие",
  unavailability_deactivated: "Бележката за отсъствие е деактивирана",
  unavailability_end_date_required: "Крайната дата е задължителна",
  start_time_before_end_time: "Началният час трябва да е преди крайния час",
  loading: "Зареждане",
  disabled: "Деактивирано",
  enable: "Активирай",
  disable: "Деактивирай",
  forwarded: "Препратено",
  message_forwarded: "Съобщението е препратено!",
  // Schedule Article
  schedule_article_post: "Насрочи публикуване на статия",
  date: "Дата",
  time: "Час",
  scheduled_for_publication: "Насрочено за публикуване",
  article_will_be_published_on: "Статията ще бъде публикувана на:",
  reset_selection: "Нулирай избор",
  continue: "Продължи",
  cancel: "Отмени",
  // Member Selection
  error_loading_members: "Грешка при зареждане на членове",
  please_fill_all_fields: "Моля, попълнете всички полета",
  invalid_email: "Невалиден e-mail адрес",
  member_added_successfully: "Членът е добавен успешно",
  error_onboarding_user: "Грешка при добавяне на потребител",
  error_creating_chat: "Грешка при създаване на чат",
  error_creating_group: "Грешка при създаване на група",
  new_group: "Нова група",
  please_select_or_enter_group_name: "Моля, изберете група или въведете име на група",
  please_select_or_enter_room_name: "Моля, изберете проект или въведете име на проект",
  error_creating_room: "Грешка при създаване на проект",
  error_opening_chat: "Грешка при отваряне на чат",
  privacy_modal_text: "Изберете \"Лично\" само ако чатът не съдържа релевантно професионално съдържание за проектния мениджър.",
  not_private: "Не е лично",
  private: "Лично",
  error_loading_groups: "Грешка при зареждане на групи",
  automatic_chat_export: "Автоматичен експорт на чат",
  automatic_chat_export_info: "След активиране, историята на чата ще се изпраща автоматично на посочения e-mail адрес всеки месец.",
  automatic_chat_export_no_email: "За да активирате автоматичния експорт на чат, първо трябва да добавите имейл адрес. Можете да добавите своя имейл адрес в личните настройки.",
  enter_email: "Въведете e-mail",
  update: "Актуализация",
  confirm: "Потвърди",
  export_to_email: "Експортът отива на следния e-mail.",
  start_chat_button:"Ново съобщение",
  matching_existing_chats: "Съответстващи съществуващи чатове",
  subject: "Тема",
  add_subject: "Добави тема",
  chat_subject: "Тема на чата:",
  set_project_room: "Задай проект",
  matching_existing_project_rooms: "Съответстващи съществуващи проекти",
  name_project_room: "Именувай проект",
  professional_or_private: "Професионално или лично",
  professional: "Професионално",
  privacy_modal_text_updated: "Изберете \"Лично\" само ако чатът не съдържа релевантно професионално съдържание за проектните мениджъри. Личните чатове не са видими за проектните мениджъри.",
  create_internal_chat: "Външен - или вътрешен чат?",
  internal_chat_description: "Само служители на вашата компания могат да бъдат добавени към вътрешни чатове.",
  yes: "Да",
  no: "Не",
  chat_is_being_created: "Чатът се създава...",
  // Additional translations for hardcoded text
  discard_article_confirm: "Наистина ли искате да отхвърлите промените по тази статия?",
  please_enter_article_title: "Моля, първо въведете заглавието на статията.",
  please_add_mandatory_fields: "Моля, добавете всички задължителни полета",
  product_label: "Продукт:",
  no_companies_found: "Не са намерени компании",
  visible_to_all_followers: "Видимо за всички членове на Kjuup",
  only_visible_to_employees: "Видимо само за служители",
  something_went_wrong: "Нещо се обърка, моля опитайте отново",
  please_select_department: "Моля, изберете отдел/местоположение",
  schedule: "Насрочи",
  please_select_future_date_time: "Моля, изберете бъдеща дата и час за насрочване на статията.",
  please_select_different_date_time: "Моля, изберете различна дата или час за насрочване на статията.",
  please_select_later_time: "Моля, изберете час по-късно от текущия час за днес.",
  unpin_article: "Откачи статия",
  pin_article: "Закачи статия",
  and: "и",
  others: "други",
  at: "в",
  // Chat mute/unmute translations
  mute: "Заглуши",
  unmute: "Отмени заглушаване",
  chat_muted_successfully: "Чатът е заглушен успешно",
  chat_unmuted_successfully: "Заглушаването на чата е отменено успешно",
  mute_chat_confirm: "Наистина ли искате да заглушите този чат? Вече няма да получавате известия за нови съобщения.",
  unmute_chat_confirm: "Наистина ли искате да отмените заглушаването на този чат? Отново ще получавате известия за нови съобщения.",
  please_select_group_to_forward: "Моля, изберете група за препращане на съобщение",
  // Company translations
  record_not_found: "Записът не е намерен!",
  please_select_position: "Моля, изберете позиция",
  delete_article_confirm: "Сигурни ли сте, че искате да изтриете тази статия?",
  delete_company_service_confirm: "Сигурни ли сте, че искате да изтриете услугата на компанията?",
  block_translation_confirm: "Наистина ли искате да блокирате автоматичното превеждане в проекти за всички членове на компанията",
  unblock_translation_confirm: "Наистина ли искате да отблокирате автоматичното превеждане в проекти за всички членове на компанията",
  please_select_file: "Моля, изберете файл за качване",
  role_in_building_industry: "Роля в строителната индустрия*",
  invalid_email_address: "Невалиден e-mail адрес",
  please_enter_password: "Моля, въведете парола",
  password_change_email_sent: "Имейл беше изпратен на вашия имейл Kjuup. Потвърдете новата си парола, като щракнете върху връзката за потвърждение в имейла.",
  please_enter_username: "Моля, въведете потребителско име",
  username_same_as_before: "Потребителското име не може да бъде същото като преди",
  profile_deleted_successfully: "Профилът е изтрит успешно",
  hardware_requirements: "Хардуерни изисквания",
  hardware_requirements_list: "• 4GB RAM<br/>• Скорост на процесора мин. 2GHz<br/>• Windows 7 или по-нова / всички версии на macOS",
  submitting: "Изпращане...",
  signing_in: "Влизане...",
  please_enter_service_name: "Моля, въведете име на услуга",
  something_went_wrong_error: "Ааах! Нещо се обърка...",
  something_went_wrong_try_again: "Съжалявам, нещо се обърка там. Опитайте отново",
  position_label: "Позиция:",
  loading_room: "Зареждане на проект...",
  navigating_to_room: "Навигация към проекта",
  loading_chat: "Зареждане на чат...",
  translate: "Преведи",
  show_original: "Покажи оригинал",
  saving: "Запазване...",
  language_selection_info: "Изборът на език се използва за всички потвърждения по e-mail, свързани с компанията.",
  // Navigation bar labels
  nav_call: "Обаждане",
  nav_home: "Начало",
  nav_messages: "Съобщения",
  nav_todo: "задачи",
  nav_rooms: "Проекти",
  nav_all_rooms: "Всички проекти",
  pinned_rooms_max: "Можете да закачите до 10 проекта.",
  pinned_room_unpin: "Откачи",
  pinned_rooms_drop: "Плъзнете проекта тук за бърз избор",
  nav_profile: "Профил",
  nav_company: "Компания",
  nav_company_documents: "Документи",
  nav_logout: "Излизане",
  // Create message dialog
  add_member_title: "Добави член",
  continue_btn: "Продължи",
  search_placeholder: "Търсене",
  no_members_found: "Не са намерени членове",
  no_groups_found: "Не са намерени групи",
  no_rooms_found: "Не са намерени проекти",
  search_users_tab: "Потребители",
  search_documents_tab: "Документи",
  company_documents: "Company documents",
  company_documents_empty: "No documents available.",
  no_media_available: "Няма файлове",
  no_documents_available: "No documents",
  searching_users: "Търсене на потребители...",
  no_users_found: "Няма намерени потребители",
  search_emails_tab: "Имейл",
  searching_emails: "Търсене на имейли...",
  no_emails_found: "Не са намерени имейли",
  search_email_addresses_tab: "E-Mail Addresses",
  search_email_content_tab: "E-Mail Content",
  searching_email_content: "Searching email content...",
  no_email_content_found: "No email content found",
  search_email_attachments_tab: "E-Mail Attachments",
  searching_email_attachments: "Searching attachments...",
  no_email_attachments_found: "No attachment matches found",
  email_attachments_label: "Attachments",  searching_email_addresses: "Searching addresses...",
  no_email_addresses_found: "No address matches found",
  email_subject_label: "Subject",
  email_body_label: "Body",
  email_address_received: "Received",
  email_address_sent: "Sent",
  unnamed_group: "Група без име",
  unnamed_room: "Проект без име",
  all_members: "Всички",
  room_label: "Проект:",
  subject_label: "Тема:",
  no_members: "Няма членове",
  // Loading states for room creation
  creating_structure: "Създаване на вашата структура",
  opening_chat: "Отваряне на чата",
  please_wait: "Моля, изчакайте...",
  // ToDo page translations
  loading_todo: "Зареждане на ToDo...",
  task_updated: "Задачата е актуализирана",
  error_updating_task: "Грешка при актуализиране на задача",
  task_deleted: "Задачата е изтрита",
  error_deleting_task: "Грешка при изтриване на задача",
  delete_task_confirm: "Сигурни ли сте, че искате да изтриете тази задача?",
  description_label: "Описание",
  description_placeholder: "Въведете описание...",
  date_time_label: "Дата и час",
  save_hint: "Ctrl+Enter за запазване, Esc за отмяна",
  edit_label: "Редактирай",
  delete_label: "Изтрий",
  todo_list_title: "задачи",
  tasks_count: "задачи",
  search_placeholder_todo: "Търсене...",
  select_task_to_open_chat: "Изберете задача, за да отворите чата",
  today: "Днес",
  yesterday: "Вчера",
  time_suffix: "", // Empty for Bulgarian (24h format doesn't need suffix)
  from_chat: "Изходна задача",
  assigned_to: "Назначено на",
  assign_users: "Назначи потребители",
  no_users_assigned: "Няма назначени потребители",
  assign: "Назначи",
  assign_to: "Назначи на...",
  navigate_to_chat: "Навигирай към чат",
  navigate_to_email: "Отиди на имейла",
  show_original_message: "Покажи източник",
  hide_original_message: "Скрий източник",
  status_pending: "В изчакване",
  status_in_progress: "В процес",
  status_completed: "Завършено",
  show: "Покажи",
  close: "Затвори",
  // Log translation strings
  status_confirmed: "[Потвърдено]",
  log_todo_created: "Задача [създадена]",
  log_todo_confirmed: "Задача [потвърдена]",
  log_todo_deleted: "Задача [изтрита]",
  log_todo_updated: "Задача [актуализирана]",
  log_description_updated: "[Описанието е актуализирано]",
  log_deadline_updated: "[Крайният срок е актуализиран]",
  log_assigned_to: "[Назначено на] {name}",
  log_unassigned_from: "[Премахнато назначение от] {name}",
  log_assignment_added: "[Назначение добавено]: {name}",
  log_assignment_removed: "[Назначение премахнато]: {name}",
  log_status_updated: "[Статусът е променен от] {from} [на] {to}",
  log_status_changed: "[Статусът е променен]",
  log_status_changed_to: "[Статусът е променен на] {status}",
  log_changed_status_to: "[Промени статуса на]:",
  log_for_user: "[за потребител]:",
  log_user_updated_status: "[Потребителят актуализира своя статус на задача]",
  log_changed_date_to: "[Промени датата на]:",
  log_changed_description_to: "[Промени описанието на]:",
  log_moved_to: "[Преместено на] {status}",
  todo_status_updated_from: "[от]",
  todo_status_updated_to: "[на]",
  filter_pending: "Чакащи",
  filter_confirmed: "Потвърдени",
  filter_assigned_to_me: "Моите задачи",
  filter_assigned_by_me: "Делегирано",
  todo_project_label: "Проект:",
  assigned_users: "Назначени потребители:",
  todo_chat_label: "Чат:",
  history: "История",
  todo_assigned_by: "Възложено от:",
  todo_assigned_push: "Възложено ToDo:",
  todo_assigned_push_empty: "На вас е възложено ново ToDo.",
  search_groups: "Групи",
  search_chat_groups: "Чат групи",
  search_project_room: "Проект",
  search_messages_tab: "Съобщения",
  searching_groups: "Търсене на групи...",
  searching_rooms: "Търсене на проекти...",
  no_groups_found: "Няма намерени групи",
  no_rooms_found: "Няма намерени проекти",
  create_poll: "Анкета",
  poll_question_label: "ВЪПРОС",
  poll_question_placeholder: "Задайте въпрос",
  poll_options_label: "ОПЦИИ",
  poll_option: "Опция",
  poll_add_option: "Добави опция",
  poll_allow_multiple: "Позволи множество отговори",
  poll_multiple_allowed: "Изберете една или повече опции",
  poll_select_option: "Изберете една опция",
  poll_view_votes: "Преглед на гласовете",
  poll_vote_singular: "глас",
  poll_vote_plural: "гласа",
  poll_votes: "Резултати от анкетата",
  poll_no_votes_yet: "Все още няма гласове",
  transcript_step_processing: "Транскрипцията е в ход...",
  ai_transcript_tab: "AI-Транскрипция",
  ai_transcript_info: "Налично само за гласови съобщения, създадени след 09.03.2026.",
  transcript_more: "...повече",
  transcript_less: "...по-малко",
  ki_transcript_voice_message: "KI-Транскрипция на гласово съобщение",
  ki_image_analysis: "AI анализ на изображения",
  type_message: "Въведете съобщение",
  email_tab_messages: "Съобщения",
  email_tab_email: "Имейл",
  email_tab_messages_and_email: "Messages & E-Mail",
  email_tab_email_details: "E-Mail Details",
  email_accounts: "Имейл акаунти",
  email_connect_gmail: "Свържете Gmail",
  email_connect_outlook: "Свържете Outlook",
  email_no_accounts: "Няма свързани имейл акаунти",
  email_no_accounts_hint: "Свържете имейл акаунт в настройките на профила",
  email_no_messages: "Няма имейли",
  email_from: "От",
  email_to: "До",
  email_subject: "Тема",
  email_disconnect: "Откачете",
  email_disconnect_confirm: "Сигурни ли сте, че искате да отмените този имейл акаунт? Всички синхронизирани имейли ще бъдат премахнати.",
  email_account_disconnected: "Имейл акаунтът е прекъснат успешно",
  email_account_disconnect_failed: "Неуспешно прекъсване на акаунта",
  email_connecting: "Свързване...",
  email_account_connected: "Акаунтът е свързан успешно",
  email_signature: "Signature",
  email_signature_placeholder: "Enter your email signature...",
  email_signature_save: "Save",
  email_signature_saved: "Saved",
  email_go_to_settings: "Отидете на настройки",
  email_date: "Дата",
  email_reply: "Отговор",
  email_forward: "Препращане",
  email_copy_text: "Копиране на текста",
  email_text_copied: "Копирано!",
  email_text_copy_failed: "Текстът не можа да бъде копиран.",
  email_delete: "Изтриване",
  email_not_spam: "Не е спам",
  email_not_spam_success: "Имейлът е преместен във входящата поща.",
  email_not_spam_failed: "Неуспешно преместване във входящата поща.",
  email_delete_confirm: "Сигурни ли сте, че искате да изтриете този имейл?",
  email_delete_from_folder: "Сигурни ли сте, че искате да изтриете от {folder}?",
  email_delete_permanent_from_folder:
    "Сигурни ли сте, че искате окончателно да изтриете от {folder}? Това действие не може да бъде отменено.",
  email_save_draft_confirm: "Искате ли да запазите този имейл като чернова?",
  email_save_draft: "Запази черновата",
  email_discard: "Отхвърли",
  email_back_to_compose: "Назад към писането",
  email_draft_saved: "Черновата е запазена.",
  email_draft_save_failed: "Неуспешно запазване на черновата.",
  email_loading: "Зареждане на имейли...",
  email_archived: "Archived",
  email_mark_spam: "Mark as spam",
  email_marked_spam: "Marked as spam",
  email_group_today: "Today",
  email_group_yesterday: "Yesterday",
  email_group_this_week: "This week",
  email_group_earlier: "Earlier",
  email_search: "Search",
  email_search_placeholder: "Search mail",
  email_no_results: "No matching messages",
  email_clear_search: "Clear search",
  email_star: "Star",
  email_unstar: "Unstar",
  email_starred: "Starred",
  email_folder_starred: "Starred",
  email_select: "Избери",
  email_attachment_singular: "Прикачен файл",
  email_attachment_plural: "Прикачени файлове",
  email_back: "Назад",
  email_download: "Изтегли",
  email_close: "Затвори",
  email_preview: "Преглед",
  email_preview_not_available: "Прегледът не е наличен",
  email_preview_failed: "Прегледът не е наличен",
  select_attachments: "Избери прикачени файлове",
  email_loading_preview: "Зареждане на преглед...",
  email_mark_unread_failed: "имейл(и) не можаха да бъдат маркирани като непрочетени.",
  email_delete_failed: "имейл(и) не можаха да бъдат изтрити.",
  filter_all: "Всички",
  filter_email: "E-Mail",
  filter_kjuup_messages: "Kjuup",
  filter_direct_messages: "Директни съобщения",
  my_notes: "My Space",
  filter_internal_groups: "Вътрешни групови чатове",
  filter_external_groups: "Външни групови чатове",
  filter_group_chats: "Групови чатове",
  filter_groups_internal: "Вътрешни",
  filter_groups_external: "Външни",
  filter_unread_only: "Само непрочетени",
  room_daily_briefing_info: "Когато е активирано, отчет за този проект се генерира на всеки 24 часа в часа, зададен в личните настройки — но само ако през този период е имало активност.",
  email_select_all: "Избери всички",
  email_deselect_all: "Премахни избора",
  email_reply_all: "Отговори на всички",
  email_reply_placeholder: "Напишете отговора си...",
  email_forward_placeholder: "Добавете съобщение...",
  email_edit_draft: "Редактиране на чернова",
  email_attach: "Прикачи",
  email_attachment_from_original: "От оригиналното съобщение",
  email_remove: "Премахни",
  email_drop_files: "Пуснете файлове за прикачване",
  email_loading_attachments: "Зареждане на прикачени файлове...",
  email_archive: "Архивирай",
  mark_unread: "Маркирай като непрочетено",
  mark_read: "Маркирай като прочетено",
  email_all_accounts: "Всички акаунти",
  email_error: "Грешка",
  email_delete_email_failed: "Неуспешно изтриване на имейл.",
  enter_url: "Въведете URL",

  // ─── Kjuup subscription ───────────────────────────────────────────
  kjuup_io: 'Kjuup.io',
  kjuup_io_manage_subscription: 'Manage your subscription',
  kjuup_io_subscribe_now: 'Абонирай се сега',
  kjuup_io_hero_subtitle: 'Upgrade to unlock premium features and get more out of every project.',
  kjuup_io_trial_badge: '1 МЕСЕЦ БЕЗПЛАТЕН ПРОБЕН ПЕРИОД',
  kjuup_io_trial_title: 'Unlock Kjuup.io Premium',
  kjuup_io_trial_subtitle: 'Connect your email, receive AI-powered smart replies and synchronize your tasks with your calendar.',
  kjuup_io_trial_no_payment: 'No payment today.',
  kjuup_io_trial_trust: 'Няма плащане днес. Не се изискват данни за кредитна карта преди началото на платения абонамент.',
  kjuup_io_after_trial_monthly: 'After trial: {price}/month',
  kjuup_io_after_trial_yearly: 'After trial: {price}/year',
  kjuup_io_price_per_month: '{price}/month',
  kjuup_io_price_per_year: '{price}/year',
  kjuup_io_start_free_trial: 'Start free now � no risk',
  kjuup_io_trial_footnote: 'No payment today. Then {price}. Cancel anytime.',
  kjuup_io_feature_email: 'Управлявайте всички имейл акаунти директно в Kjuup',
  kjuup_io_feature_assign: 'Automatically assign emails and attachments to projects',
  kjuup_io_feature_ai: 'ИИ пише отговорите – вие само потвърждавате',
  kjuup_io_feature_tasks: 'Задачите и календарът винаги са автоматично актуални',
  kjuup_io_choose_plan: 'Изберете план',
  kjuup_io_plan_monthly: 'Месечно',
  kjuup_io_plan_yearly: 'Годишно',
  kjuup_io_plan_monthly_desc: 'Billed monthly · cancel anytime',
  kjuup_io_plan_yearly_desc: 'Save {pct}% with annual booking',
  kjuup_io_save_badge: 'SAVE {pct}%',
  kjuup_io_per_month_annual: '{price} / month · Save {pct}% with annual booking',
  kjuup_io_subscribe: 'Subscribe',
  kjuup_io_secured_stripe: 'Защитено от Stripe · прекратяване по всяко време',
  kjuup_io_your_subscription: 'YOUR SUBSCRIPTION',
  kjuup_io_status_active: 'ACTIVE',
  kjuup_io_status_cancels_soon: 'CANCELS SOON',
  kjuup_io_status_switch_scheduled: 'SWITCH SCHEDULED',
  kjuup_io_label_plan: 'Plan',
  kjuup_io_label_price: 'Price',
  kjuup_io_label_status: 'Status',
  kjuup_io_label_renews: 'Renews on',
  kjuup_io_label_access_until: 'Access until',
  kjuup_io_switching_to: 'Switching to {plan} on {date}',
  kjuup_io_cancel_pending_note: 'Your subscription is set to cancel and won\'t renew. You keep access until the date above.',
  kjuup_io_resume: 'Resume subscription',
  kjuup_io_switch_to_plan: 'Switch to {plan} plan',
  kjuup_io_undo_switch: 'Undo scheduled change',
  kjuup_io_cancel_subscription: 'Cancel subscription',
  kjuup_io_switch_modal_title: 'Switch to {plan} plan?',
  kjuup_io_billed_yearly: 'Billed yearly',
  kjuup_io_billed_monthly: 'Billed monthly',
  kjuup_io_switch_modal_note: 'Starts on {date}, when your current {plan} plan ends. No charge today — you keep your current plan until then.',
  kjuup_io_confirm_switch: 'Confirm switch',
  kjuup_io_not_now: 'Not now',
  kjuup_io_cancel_modal_title: 'Cancel subscription?',
  kjuup_io_cancel_modal_note: 'You\'ll keep access to Kjuup.io until the end of your current billing period. After that it won\'t renew.',
  kjuup_io_cancel_modal_note_with_date: 'You\'ll keep access to Kjuup.io until the end of your current billing period ({date}). After that it won\'t renew.',
  kjuup_io_cancel_plan: 'Cancel plan',
  kjuup_io_keep_subscription: 'Keep my subscription',
  kjuup_io_toast_payment_failed: 'Payment failed',
  kjuup_io_toast_activating: 'Плащането е получено. Абонаментът се активира…',
  kjuup_io_toast_activating_soon: 'Плащането е получено. Абонаментът ви ще бъде активиран скоро.',
  kjuup_io_toast_cancel_period: 'Your subscription will cancel at the end of the period',
  kjuup_io_toast_cancel_fail: 'Unable to cancel subscription',
  kjuup_io_toast_switch_scheduled: 'You\'ll move to the {plan} plan when your current period ends',
  kjuup_io_toast_switch_fail: 'Unable to switch plan',
  kjuup_io_toast_resumed: 'Your subscription will keep renewing',
  kjuup_io_toast_resume_fail: 'Unable to resume subscription',
  kjuup_io_toast_undo: 'Scheduled plan change canceled',
  kjuup_io_toast_undo_fail: 'Unable to cancel the scheduled change',
  kjuup_io_email_locked_body: 'Email is part of Kjuup.io. Activate a plan to use the Email tab.',
  kjuup_io_connect_email: 'Connect email with Kjuup.io',
  kjuup_io_activate_to_connect_email: 'Activate Kjuup.io to connect email accounts',

  kjuup_io_trial_no_card: 'No credit card details are requested before your paid subscription starts.',
  kjuup_io_status_trialing: 'TRIAL',
  kjuup_io_trial_days_left: '{days} days left in your free trial',
  kjuup_io_trial_left_hours: 'Остават {count} ч',
  kjuup_io_trial_left_hour: 'Остава 1 час',
  kjuup_io_trial_left_minutes: 'Остават {count} мин',
  kjuup_io_trial_left_minute: 'Остава 1 минута',
  kjuup_io_trial_left_seconds: 'Остават {count} сек',
  kjuup_io_trial_left_second: 'Остава 1 секунда',
  kjuup_io_trial_ending_now: 'Пробният период приключва…',
  kjuup_io_request_timeout: 'Времето за връзка изтече. Опитайте отново.',
  kjuup_io_info_days_free: '{days} дни напълно безплатно – абонаментът започва едва след пробния период.',
  kjuup_io_discount_total: 'Вашата отстъпка: {percent}%',
  kjuup_io_discount_company: '{company}: {percent}%',
  kjuup_io_discount_personal: 'Лична: {percent}%',
  kjuup_io_trial_ends_tomorrow: 'Your free trial ends tomorrow',
  kjuup_io_trial_ends_today: 'Your free trial ends today',
  kjuup_io_banner_dismiss: 'Затвори',
  kjuup_io_billing_after_trial: 'You\'ll be charged after your trial ends on {date}.',
  kjuup_io_trial_ended_title: 'Безплатният ви пробен период приключи',
  kjuup_io_trial_ended_body: 'Абонирайте се за Kjuup.io, за да продължите да използвате имейл и други премиум функции.',
  kjuup_io_subscribe_to_continue: 'Subscribe now to continue',
  kjuup_io_trial_active_title: 'You\'re on a free trial',
  kjuup_io_trial_active_subtitle: 'Choose a plan and subscribe — billing starts when your trial ends.',
  kjuup_io_toast_trial_started: 'Безплатният ви пробен период започна',
  kjuup_io_toast_trial_fail: 'Пробният период не можа да бъде стартиран',
  kjuup_io_trial_try_month: 'Try Kjuup.io free for one month.',
  kjuup_io_per_month: 'per month',
  kjuup_io_price_month_line: '{price} / месец',
  kjuup_io_save_amount_year: 'Спестете {price} годишно',
  kjuup_io_billed_annually_amount: '{price} таксувани годишно',
  kjuup_io_save_yearly: 'Save {pct}% with yearly billing.',
  kjuup_io_savings_pct: '{pct}% savings',
  kjuup_io_features_title: 'Какво получавате:',
  kjuup_io_info_one_month_free: 'One month free',
  kjuup_io_info_plan_after_trial: 'Your selected subscription starts after the trial.',
  kjuup_io_info_cancel_trial: 'Cancel anytime during the trial.',
  kjuup_io_info_no_card: 'Не е необходима кредитна карта – започнете веднага без платежни данни.',
  kjuup_io_info_cancel_anytime: 'Отказ по всяко време – без ангажимент, без риск.',
  kjuup_io_cta_plan_begins: 'Your selected plan begins after the free trial.',
  kjuup_io_billing_period_aria: 'Период на фактуриране',
  kjuup_io_subscription_info_title: 'Subscription information',
  kjuup_io_first_payment_on: 'First payment on {date}.',
  kjuup_io_renews_on: 'Renews on {date}.',
  kjuup_io_toast_card_saved: 'Методът на плащане е запазен. Таксуването ще бъде в края на пробния период.',
  calendar_sync_info: 'Автоматично синхронизирайте всички Kjuup ToDo с вашия календар.',
  calendar_no_accounts: 'Все още няма свързан календар.',
  article_new_badge: 'НОВО',
  article_new_posts: '{0} нови публикации',
  documents: 'Документи',
  add_documents: 'Добавяне на документи',
  no_preview_available: 'Няма налична визуализация',
  no_preview_hint: 'Този тип файл не може да бъде визуализиран, но въпреки това ще бъде изпратен.',
  max_documents_reached: 'Можете да прикачите до 10 документа наведнъж.',
  open_file: 'Отваряне на файла',
  twofa_title: 'Двуфакторно удостоверяване',
  twofa_method_totp: 'Приложение за удостоверяване',
  twofa_method_sms: 'SMS',
  twofa_method_email: 'Имейл',
  twofa_enter_app: 'Въведи 6-цифрения код от приложението.',
  twofa_enter_sms: 'Въведи 6-цифрения код от SMS.',
  twofa_enter_email: 'Въведи 6-цифрения код от имейла.',
  twofa_resend: 'Изпрати кода отново',
  twofa_try_another: 'Друг метод',
  twofa_remember_device: 'Не питай на това устройство 30 дни',
  twofa_sent: 'Изпратихме код.',
  twofa_invalid_code: 'Този код е грешен. Опитай отново.',
  twofa_something_wrong: 'Нещо се обърка. Опитай отново.',
  twofa_method_unavailable: 'Този метод не е наличен.',
  twofa_on_desc: 'Двуфакторното удостоверяване е включено. При всеки вход ще трябва код.',
  twofa_off_desc: 'Добави втора стъпка след паролата. Приложенията са най-сигурният вариант.',
  twofa_methods: 'Методи',
  twofa_on: 'Вкл.',
  twofa_add: 'Добави',
  twofa_default_method: 'Метод по подразбиране',
  twofa_default: 'По подразбиране',
  twofa_turn_off: 'Изключи',
  twofa_disable_hint: 'Въведи паролата и текущ код, за да изключиш двуфакторното удостоверяване.',
  twofa_disable_need: 'Въведи паролата и код за потвърждение.',
  twofa_code_placeholder: '6-цифрен или резервен код',
  twofa_send_code: 'Изпрати код',
  twofa_primary_updated: 'Методът по подразбиране е обновен.',
  twofa_disabled: 'Двуфакторното удостоверяване е изключено.',
  twofa_enabled: 'Двуфакторното удостоверяване е включено.',
  twofa_totp_help: 'Сканирай този QR код с Google Authenticator, Authy или 1Password. Можеш да въведеш ключа и ръчно.',
  twofa_secret_copied: 'Ключът е копиран',
  twofa_sms_help: 'Въведи номера в международен формат. Ще изпратим 6-цифрен код по SMS.',
  twofa_email_help: 'Ще изпратим 6-цифрен код на имейла на акаунта.',
  twofa_backup_title: 'Резервни кодове',
  twofa_backup_help: 'Пази тези еднократни кодове на сигурно място. Всеки код се ползва веднъж, ако загубиш телефона.',
  twofa_copy_codes: 'Копирай кодовете',
  twofa_codes_copied: 'Резервните кодове са копирани',
  twofa_regenerate: 'Вземи нови резервни кодове',
  twofa_regenerate_hint: 'Това заменя неизползваните резервни кодове. Въведи паролата и актуален код.',
  twofa_backup_remaining: 'Остават {n} неизползвани резервни кодове',
  twofa_new_codes: 'Нови резервни кодове',
  twofa_sms_unavailable: 'SMS кодовете все още не са налични.',
  todoist_sync_title: "Todoist",
  todoist_sync_info: "Възложените ви задачи в Kjuup се копират в проект „Kjuup“ във вашия Todoist. Промените в Todoist не се копират обратно.",
  todoist_connect: "Свързване на Todoist",
  todoist_connected: "Todoist е свързан",
  todoist_connect_failed: "Връзката с Todoist не успя",
  todoist_disconnect: "Прекъсване",
  todoist_disconnected: "Todoist е прекъснат",
  todoist_disconnect_confirm: "Прекъсване на Todoist? Задачите, които вече са в Todoist, остават. Синхронизирането спира.",
  todoist_sync_now: "Синхронизирай сега",
  todoist_syncing: "Синхронизиране…",
  todoist_sync_done: "Синхронизирането приключи",
  todoist_sync_failed: "Синхронизирането не успя",
  todoist_auth_error: "Свържете Todoist отново, за да продължи синхронизирането.",
  todoist_last_sync: "Последна синхронизация",
  todoist_not_connected: "Todoist не е свързан",
  todoist_auth_url_failed: "Страницата за упълномощаване на Todoist не можа да се отвори.",
  recommend_text: "Присъедини се към Kjuup, за да останеш на връзка и да държиш комуникацията си организирана. Събери каналите си на едно място, дръж съобщенията в правилните проекти и започвай всяка сутрин с обобщение и задачите си – всичко синхронизирано с приложенията, които вече използваш. Започни безплатно:",
  pro_auth_signin_title: 'Добре дошли отново',
  pro_auth_signin_sub: 'Влезте със служебния си имейл.',
  pro_auth_email_or_username: 'Имейл или потребителско име',
  pro_auth_email_placeholder: 'name@company.de',
  pro_auth_forgot_password: 'Забравена парола?',
  pro_auth_create_account: 'Създай акаунт',
  pro_auth_show_password: 'Покажи паролата',
  pro_auth_hide_password: 'Скрий паролата',
  pro_auth_register_sub: 'Ще ви изпратим линк за потвърждение на вашия имейл.',
  pro_auth_register_plus_sub: 'Изберете потребителско име и парола. След това задавате вашия ПИН за сигурност.',
  pro_auth_check_credentials: 'Проверете вашия имейл и парола',
  pro_news_export_pdf: 'Експортирай като PDF',
  pro_news_pdf_failed: 'PDF файлът не можа да бъде създаден.',
  pro_news_pdf_attachments: 'Прикачени файлове',
  pro_news_pdf_video: 'Видео',
  pro_auth_forgot_sub: 'Въведете вашия имейл и ще ви изпратим линк за нулиране на паролата.',
  pro_auth_send_link: 'Изпрати линк за нулиране',
  pro_auth_plus_reset: 'Нулиране с ПИН',
  pro_auth_show_pin: 'Покажи ПИН',
  pro_auth_hide_pin: 'Скрий ПИН',
  v2_auth_plus_only: 'Само за Kjuup+',
  room_action_media: "Файлове",
  room_tab_overview: "Обзор",
  room_tab_history: "История",
  chat_info_media: "Файлове",
  messages: "съобщения",
  pro_todo_project_required: "Моля, изберете проект",
  pro_todo_choose_project: "За кой проект е тази задача?",
  cockpit_report_delete_confirm: "Да изтрия ли този дневен отчет?",
  cockpit_report_deleted: "Дневният отчет е изтрит",
  cockpit_tab_company: "Фирма",
  cockpit_bookmarked_priorities: "Запазени задачи",
  cockpit_load_error: "Cockpit не можа да се зареди.",
  cockpit_retry: "Опитайте отново",
  cockpit_yesterday: "Вчера",
  cockpit_greeting_morning: "Добро утро",
  cockpit_greeting_day: "Добър ден",
  cockpit_greeting_evening: "Добър вечер",
  cockpit_assistant_q_open: "Какво е отворено днес?",
  cockpit_assistant_q_summarize: "Обобщи чата {{room}}",
  cockpit_assistant_q_overdue: "Кои задачи са просрочени?",
  cockpit_assistant_new: "{{n}} нови",
  cockpit_assistant_important: "{{n}} важни",
  cockpit_assistant_title: "Kjuup асистент",
  cockpit_assistant_hint: "Докоснете и попитайте",
  room_overview_priority_no_detail: "Отчетът не дава повече подробности за този приоритет.",
  room_overview_priority_from: "Източник: {{name}}",
  room_overview_priority_open_task: "Отвори задачата",
  cockpit_priority_position: "{{index}} от {{total}} приоритета",
  room_overview_today_title: "Важно днес",
  room_overview_all_tasks: "Всички",
  room_overview_tasks_empty: "Няма отворени срокове или задачи",
  room_overview_appointments_empty: "Няма предстоящи срещи",
  room_overview_no_priorities: "Няма отворени приоритети в последния отчет.",
  cockpit_report_top5: "Топ 5 приоритета",
  cockpit_report_todo_created: "Задачата е създадена",
  cockpit_report_source_missing: "Изходното съобщение не беше намерено.",
  delete_bookmarked_priority_confirm: "Сигурни ли сте, че искате да изтриете тази запазена задача?",
  cockpit_report_create_todo: "Създай задача",
  cockpit_priorities_deleting: "Изтриване …",
  cockpit_priorities_select: "Изтрий няколко",
  cockpit_report_none: "Няма записи.",
  cockpit_priorities_delete_confirm: "Сигурни ли сте, че искате да изтриете {count} запазени задачи?",
  cockpit_priorities_delete_failed: "{count} задачи не можаха да бъдат изтрити",
  cockpit_priorities_deleted: "{count} задачи са изтрити",
  cockpit_priorities_selected: "{count} избрани",
  cockpit_channel_connected: "Свързано",
  cockpit_channel_not_connected: "Не е свързано",
  cockpit_channel_connect: "Свържи",
  cockpit_channel_chat: "Kjuup чат",
  cockpit_channel_active: "Активно",
  cockpit_channel_hidden: "Скрито",
  cockpit_channel_enable: "Включи",
  cockpit_channel_email: "Имейл",
  cockpit_channel_check: "Провери връзката",
  cockpit_channel_fix: "Провери",
  cockpit_channel_forward: "Адрес за препращане",
  cockpit_channel_not_set_up: "Не е настроено",
  cockpit_channel_set_up: "Настрой",
  cockpit_channel_teams: "Microsoft Teams",
  cockpit_channel_broken: "Връзката е прекъсната",
  cockpit_channel_importing: "Импортиране",
  cockpit_channel_removing: "Прекъсване на връзката",
  cockpit_channel_reconnect: "Свържи отново",
  cockpit_channels_title: "Канали",
  cockpit_company_role_super_admin: "Администратор на фирмата",
  cockpit_company_role_dept_admin: "Администратор на отдела",
  cockpit_company_role_member: "Служител",
  cockpit_company_none: "Не е намерена фирма с Kjuup+",
  cockpit_company_eyebrow: "Фирма",
  cockpit_company_inactive: "неактивна",
  cockpit_company_settings: "Настройки на фирмата",
  cockpit_company_employees: "Служители",
  cockpit_company_internal_rooms: "Вътрешни проекти",
  cockpit_report_all_projects: "Всички проекти",
  cockpit_report_progress_emails: "Анализиране на имейли",
  cockpit_report_progress_chats: "Анализиране на чат съобщения",
  cockpit_report_progress_documents: "Анализиране на прикачени файлове и документи",
  cockpit_report_progress_tasks: "Анализиране на задачи",
  cockpit_report_progress_summarizing: "Анализиране на съдържанието",
  cockpit_report_progress_reading: "Използване на вече анализирано съдържание",
  cockpit_report_progress_collecting: "Събиране на имейли, чатове и задачи от вашите проекти",
  cockpit_report_progress_priorities: "Съставяне на приоритети, срокове и решения",
  cockpit_report_progress_queued: "Подготовка на отчета",
  cockpit_report_creating_title: "Вашият дневен отчет се подготвя",
  cockpit_report_progress_count_one: "1 анализиран елемент",
  cockpit_report_progress_count_many: "{{count}} анализирани елемента",
  cockpit_report_progress_hint: "Обикновено отнема една до две минути – междувременно можете да продължите да използвате Cockpit.",
  cockpit_report_time_hint: "Дневният отчет се създава всеки ден в {{hour}}:00 за петте най-активни проекта.",
  room_overview_priorities_title: "Текущо състояние и приоритети",
  room_overview_as_of: "Към {{time}}",
  cockpit_report_delete: "Изтрий дневния отчет",
  email_tag_daily_briefing: "Дневен отчет",
  cockpit_report_unread: "Нов",
  cockpit_report_clear_project: "Покажи всички проекти",
  cockpit_filter_project: "Проект",
  cockpit_filter_all_projects: "Всички проекти",
  cockpit_report_recreate: "Създай дневния отчет отново",
  cockpit_report_hide_previous: "Скрий предишните дневни отчети",
  cockpit_report_show_previous: "Покажи предишните дневни отчети",
  cockpit_report_room_empty: "Все още няма дневен отчет за този проект",
  cockpit_report_empty: "Все още няма дневен отчет",
  cockpit_report_room_empty_hint: "Създайте дневен отчет само за този проект.",
  cockpit_report_needs_mailbox: "Свържете имейл акаунт, за да може Kjuup да създава дневен отчет с автоматични задачи.",
  cockpit_report_create: "Създай дневен отчет",
  cockpit_email_connect: "Свържи имейл",
  cockpit_email_none_title: "Все още няма свързан имейл акаунт",
  cockpit_email_none_reports: "Свържете пощенската си кутия, за да може Kjuup да разпределя входящите имейли към вашите проекти и да създава дневни отчети със задачи.",
  cockpit_email_none_client: "Свържете Gmail, Outlook или IMAP, за да четете, разпределяте и отговаряте на имейли директно в Kjuup.io.",
  cockpit_email_reports_title: "Текущ имейл клиент",
  cockpit_email_reports_text: "Без входяща поща в Kjuup.io · {{rooms}} проекта с дневен отчет в {{hour}}:00 · входящите имейли се разпределят към вашите проекти.",
  cockpit_email_reports_rooms: "Управление на проекти",
  cockpit_email_settings: "Настройки на имейл",
  cockpit_email_error_title: "Провери връзката",
  cockpit_email_client_title: "Входящата поща е свързана",
  cockpit_email_accounts_n: "{{n}} свързан акаунт",
  cockpit_email_last_sync: "последно синхронизиране {{when}}",
  cockpit_email_report_at: "Дневен отчет в {{hour}}:00",
  cockpit_email_open_inbox: "Отвори входящата поща",
  cockpit_email_eyebrow: "Kjuup-Email",
  cockpit_email_accounts_label: "Свързани имейл адреси",
  email_folder_sent: "Изпратени",
  email_no_subject: "(Без тема)",
  cockpit_email_detail_loading: "Имейлът се зарежда …",
  cockpit_email_detail_failed: "Имейлът не можа да се зареди.",
  cockpit_email_detail_empty: "Този имейл няма текст.",
  cockpit_personal_settings: "Лични настройки",
  cockpit_companies: "Фирми",
  cockpit_title: "Cockpit",
  cockpit_back: "Обратно към прегледа",
  cockpit_day_overview: "Вашият ден накратко",
  email_saved_to_project: "Имейлът е запазен в проекта",
  email_classify_need_project: "Моля, въведете име на проект",
  cockpit_email_deleted: "Имейлът е изтрит",
  cockpit_email_sent_empty: "Все още няма изпратени имейли.",
  cockpit_email_incoming_empty: "Все още няма входящи имейли.",
  cockpit_email_incoming_title: "Имейли",
  cockpit_email_incoming_sub: "Разпределете входящите и изпратените имейли към вашите проекти. Тук можете да коригирате разпределението.",
  cockpit_email_incoming_unassigned_n: "{{n}} неразпределени",
  cockpit_email_folder_inbox: "Входящи",
  cockpit_email_folder_sent: "Изпратени",
  cockpit_email_open: "Отвори имейла",
  cockpit_email_incoming_suggested: "Предложение: {{room}}",
  cockpit_email_incoming_apply: "Приложи",
  cockpit_email_incoming_adjust: "Промени разпределението",
  cockpit_email_incoming_saving: "Запазване …",
  cockpit_email_incoming_unassigned: "Неразпределен",
  cockpit_email_incoming_show_less: "Покажи по-малко",
  cockpit_email_incoming_show_all: "Покажи всички {{n}}",
  cockpit_io_settings: "Настройки на Kjuup.io",
  cockpit_io_settings_sub: "План и места, разпределение на служители, фактуриране и фактури.",
  products_coming_soon: "Очаквайте скоро",
  cockpit_upsell_io_title: "Вашият офис, който мисли с вас",
  cockpit_upsell_io_text: "Свържете имейл акаунтите си с Kjuup. Имейлите, прикачените файлове и съобщенията се запазват автоматично в съответния проект и по желание могат да се съхраняват на вашия сървър. Всеки ден получавате обобщение на всички проекти с най-важното от цялото съдържание, а задачите ви се синхронизират с вашия календар или приложение за задачи.",
  cockpit_upsell_io_soon_title: "Все още не може да се резервира",
  cockpit_upsell_io_soon_text: "Kjuup.io стартира скоро. Заявете информация сега – ще ви уведомим, щом можете да резервирате Kjuup.io.",
  cockpit_upsell_io_planned_price: "Планирана цена",
  cockpit_upsell_io_cta_request: "Заявка за информация",
  kjuup_plus_abo_per_year: "/ година",
  kjuup_plus_abo_per_month: "/ месец",
  kjuup_plus_abo_status_active: "Активен",
  kjuup_plus_abo_status_requested: "Заявено прекратяване",
  kjuup_plus_abo_status_past_due: "Дължимо плащане",
  kjuup_plus_abo_eyebrow: "Kjuup+ · Абонамент",
  kjuup_plus_abo_title: "Пакет Kjuup+",
  kjuup_plus_abo_seats_free_one: "1 свободно място",
  kjuup_plus_abo_billing: "Фактуриране",
  kjuup_plus_abo_yearly: "Годишно",
  kjuup_plus_abo_monthly: "Месечно",
  kjuup_plus_abo_amount: "Сума",
  kjuup_plus_abo_ends: "Изтича на",
  kjuup_plus_abo_renews: "Следващо подновяване",
  kjuup_plus_abo_next_invoice: "Следваща фактура",
  kjuup_plus_abo_intro: "Въвеждаща цена",
  kjuup_plus_abo_pending_tier: "От следващото подновяване",
  kjuup_plus_abo_manual: "Kjuup+ е активен за вашата фирма по индивидуално споразумение.",
  kjuup_plus_abo_invoices: "Фактури",
  kjuup_plus_abo_invoice_paid: "Платена",
  kjuup_plus_abo_invoice_view: "Преглед",
  kjuup_plus_abo_invoices_less: "Покажи по-малко",
  kjuup_plus_abo_member_hint: "Фактурирането и прекратяването се управляват от администраторите на вашата фирма.",
  kjuup_plus_abo_withdraw: "Оттегли заявката",
  kjuup_plus_abo_cancel_note: "Причина (по желание)",
  kjuup_plus_abo_cancel_send: "Заяви прекратяване",
  kjuup_plus_abo_cancel: "Прекрати абонамента",
  cockpit_upsell_plus_f1: "Управлявайте комуникационната активност на всички ваши служители",
  cockpit_upsell_plus_f2: "Информирайте определени потребителски групи във фирмата",
  cockpit_upsell_plus_f3: "Запазвайте вътрешните групови чатове",
  cockpit_upsell_plus_when_yearly: "при годишно плащане",
  cockpit_upsell_plus_size_small: "1–50 служители",
  cockpit_upsell_plus_size_large: "51–200 служители",
  cockpit_upsell_plus_title: "Kjuup+ за фирми",
  cockpit_upsell_plus_text: "Управлявайте служители, права за писане и фирмена комуникация на едно място. Вътрешните канали остават във вашия екип, външните канали ви свързват с партньори по проекти, а определени групи можете да достигате директно. Освен Kjuup+ можете да резервирате достъп до Kjuup.io за групи служители. Kjuup+ и Kjuup.io могат да се комбинират.",
  cockpit_upsell_plus_size: "Размер на фирмата",
  cockpit_upsell_plus_billing: "Фактуриране",
  cockpit_upsell_plus_per_company: "/ фирма · месец без ДДС",
  cockpit_upsell_plus_onboarding: "Разходите за въвеждане/обучение зависят от размера на фирмата",
  cockpit_upsell_plus_larger: "Цени за по-големи фирми при запитване",
  cockpit_upsell_plus_cta: "Запитване без ангажимент",
  cockpit_kpi_deadlines_tasks: "Срокове и задачи",
  cockpit_kpi_appointments: "Срещи",
  cockpit_room_admin: "Управление на проекти и чатове",
  cockpit_room_admin_sub: "Всички проекти на фирмата с членове, медия и чатове.",
  pro_todo_not_found: "Тази задача вече не е налична.",
  cockpit_chip_overdue: "Просрочени",
  cockpit_chip_today: "Днес",
  cockpit_calendar_week: "Седм. {{week}}",
  cockpit_prev_week: "Предишна седмица",
  cockpit_next_week: "Следваща седмица",
  cockpit_chip_requested: "Заявени",
  cockpit_todo_due: "Срок {{when}}",
  cockpit_todo_at: "{{time}}",
  cockpit_todo_requested_from: "от {{name}}",
  cockpit_todo_since: "от {{when}}",
  cockpit_todo_no_date: "Без дата",
  cockpit_todo_mark_done: "Маркирай като изпълнена",
  cockpit_my_tasks_title: "Моите задачи",
  cockpit_today_tasks_group: "Задачи за днес",
  cockpit_assign_none: "Няма назначен",
  no_project_found: "Не е намерен проект",
  cockpit_row_more_actions: "Още действия",
  needs_date: "Задай дата",
  cockpit_assign_proposal: "Разпознат: {{name}} – да се назначи ли?",
  cockpit_assign_proposal_confirm: "Назначи",
  cockpit_assign_proposal_dismiss: "Игнорирай",
  cockpit_priority_date: "Дата",
  todo_calendar_add: "Добави в календара",
  todo_calendar_remove: "Премахни от календара",
  cockpit_todo_change_project: "Смени проекта",
  cockpit_todo_set_date: "Задай дата",
  pro_todo_done_confirm: "Наистина ли искате да маркирате тази задача като изпълнена?",
  cockpit_task_delete_failed: "Задачата не можа да бъде изтрита.",
  cockpit_setup_title: "Завършете настройката",
  cockpit_setup_text: "Решете дали искате да използвате чатове и дали Kjuup.io да работи като имейл клиент или само с проекти и дневни отчети.",
  cockpit_setup_cta: "Настрой сега",
  cockpit_group_tasks: "Срокове и задачи",
  cockpit_group_appointments: "Срещи",
  cockpit_report_no_activity: "Този проект не е имал нови съобщения или имейли през последните 24 часа.",
  cockpit_report_room_unavailable: "Този проект не е наличен.",
  cockpit_report_create_failed: "Дневният отчет не можа да бъде създаден.",
  cockpit_report_created: "Дневният отчет е създаден",
  addon_enable_confirm: "Да се включи ли добавката?",
  addon_enable: "Включи",
  addon_enabled: "Добавката е включена",
  nav_email: "Имейл",
  nav_my_cockpit: "Моят Cockpit",
  nav_news: "Новини",
  nav_recommend: "Препоръчай",
  pro_todo_status_done: "Изпълнена",
  pro_todo_status_open: "Отворена",
  v2_todo_remove: "Премахни",
  pro_todo_search_people: "Търсене на хора",
  pro_todo_clear: "Изчисти",
  pro_todo_assigned: "(назначен)",
  pro_todo_no_people: "Не са намерени хора",
  pro_todo_search_rooms: "Търсене на проекти",
  pro_todo_no_rooms_match: "Няма проекти, отговарящи на „{{q}}“",
  pro_todo_no_rooms: "Не са намерени проекти",
  pro_todo_activity: "Активност",
  pro_todo_show_less: "Покажи по-малко",
  pro_todo_show_all: "Покажи всички ({{n}})",
  pro_todo_due: "Срок",
  pro_todo_room: "Проект",
  pro_todo_select_room: "Избери проект",
  pro_todo_status: "Статус",
  pro_todo_more: "Още",
  pro_todo_edit_title: "Редактирай задачата",
  pro_todo_description: "Описание",
  pro_todo_created_by: "Създадена от",
  pro_todo_chat: "Чат",
  navigate_to_source: "Към източника",
  todo_calendar_connect_title: "Няма свързан календар",
  todo_calendar_connect_body_web: "Свържете календар в настройките за синхронизиране на календара, за да добавяте задачи към него.",
  todo_calendar_connect: "Свържи",
  todo_calendar_removed: "Премахнато от вашия календар",
  todo_calendar_added_later: "Добавено. Календарът ви не беше достъпен; Kjuup ще опита отново по-късно.",
  todo_calendar_added: "Добавено във вашия календар",
  todo_calendar_no_date: "Само задача с дата може да бъде добавена в календар.",
  todo_calendar_failed: "Календарът ви не можа да бъде обновен. Моля, опитайте отново.",
  todo_calendar_date_title: "Още няма дата",
  todo_calendar_date_save: "Задай дата и добави",
  todo_calendar_date_body_web: "Тази запазена задача все още няма дата. Задайте дата, за да я добавите във вашия календар.",
  kjuup_io_setup_saved: "Настройката е запазена",
  kjuup_io_setup_step: "Стъпка",
  kjuup_io_setup_chats_title: "Искате ли да използвате чатове?",
  kjuup_io_setup_email_title: "Къде искате да четете имейлите си?",
  kjuup_io_setup_chats_sub: "Чатовете с колеги и партньори по проекти са по желание. Можете да ги показвате или скривате в Cockpit по всяко време.",
  kjuup_io_setup_email_sub: "Това само определя дали използвате имейл клиент в Kjuup или продължавате да използвате текущата си имейл програма, например Outlook или друга. Можете да смените по-късно.",
  kjuup_io_setup_chats_yes: "Да, покажи чатовете",
  kjuup_io_setup_chats_yes_text: "„Съобщения“ включва чатове и имейли. Проектите имат групови чатове за всички участници.",
  kjuup_io_setup_chats_no: "Не, работя без чатове",
  kjuup_io_setup_chats_no_text: "Чатовете са скрити. „Съобщения“ става „Имейл“; проектите, задачите и дневните отчети остават.",
  kjuup_io_setup_email_client: "Имейл клиент в Kjuup",
  kjuup_io_setup_email_client_text: "Четете и отговаряйте на имейли директно в Kjuup.",
  kjuup_io_setup_email_reports: "Текущ имейл клиент",
  kjuup_io_setup_email_reports_text: "Продължете да четете и отговаряте в текущата си програма, например Outlook или друга.",
  kjuup_io_setup_skip: "По-късно",
  next: "Напред",
  kjuup_io_setup_finish: "Завърши настройката",
  today_label: "днес",
  tomorrow_label: "утре",
  cockpit_todo_overdue: "просрочена",
  cockpit_report_management_fazit: "Управленско резюме",
  cockpit_todo_appointment: "Среща",
  cockpit_todo_deadline: "Срок",
  cockpit_todo_deadline_define: "Определи срок",
  pro_todo_status_acknowledged: "Потвърдена",
  pro_todo_responsible: "Отговорник",
  pro_todo_notice_confirmed: "Потвърдена в чата",
  pro_todo_notice_sent_at: "Съобщението е изпратено",
  pro_todo_notice_again: "Изпрати съобщението отново",
  pro_todo_notice_send: "Информирай чрез съобщение в Kjuup",
  pro_todo_add_assignee: "Добави",
  pro_todo_edit: "Редактирай",
  pro_todo_change_room: "Смени проекта",
  pro_todo_due_on: "Срок до",
  pro_todo_edit_due: "Редактирай срока",
  pro_todo_no_date: "Без дата",
  pro_todo_edit_description: "Редактирай описанието",
  pro_todo_no_description: "Все още няма описание",
  pro_todo_title_label: "Заглавие",
  pro_todo_title_placeholder: "Въведете заглавие...",
  pro_todo_task: "Задача",
  pro_todo_what: "Какво трябва да се направи?",
  pro_todo_source_email: "Имейл",
  pro_todo_sources: "Източници",
  previous: "Предишно",
  kjuup_plus_abo_tier_large: "Kjuup+ Large (до {max} служители)",
  kjuup_plus_abo_tier_small: "Kjuup+ Small (до {max} служители)",
  kjuup_plus_abo_status_ends: "Изтича на {date}",
  kjuup_plus_abo_seats_over: "Над {max} служители – Kjuup ще се свърже с вас с индивидуална оферта.",
  kjuup_plus_abo_seats_next: "Ако се присъединят още служители, пакетът автоматично преминава към {next} (пропорционално таксуване).",
  kjuup_plus_abo_seats_used: "{used} от {total} места заети",
  kjuup_plus_abo_seats_free: "Свободни места: {count}",
  kjuup_plus_abo_intro_until: "до {date}",
  kjuup_plus_abo_invoice_open: "Неплатена · падеж {date}",
  kjuup_plus_abo_invoices_all: "Покажи всички ({count})",
  kjuup_plus_abo_requested_hint: "Прекратяването е заявено на {date}. Kjuup ще го потвърди в края на срока ({end}).",
  kjuup_plus_abo_cancel_hint: "Kjuup ще прегледа заявката ви и ще потвърди прекратяването в края на срока ({end}). Дотогава Kjuup+ остава активен.",
  kjuup_plus_abo_withdrawn: "Заявката за прекратяване е оттеглена",
  kjuup_plus_abo_requested: "Заявено прекратяване",
  cockpit_upsell_plus_intro_hint: "първите {months} месеца, след това {price}",
  cockpit_upsell_plus_badge: "ВЪВЕДИТЕЛНА ЦЕНА ЗА {months} МЕСЕЦА",
  calendar_syncing: "Обновяване от календара…",
  calendar_sync_up_to_date: "Календарът е актуален",
  calendar_sync_failed: "Синхронизацията е неуспешна",
  delete_multiple_tasks_confirm: "Сигурни ли сте, че искате да изтриете {count} ToDo?",
  todos_deleted_count: "Изтрити са {count} ToDo",
  todos_deleted_partial: "Изтрити са {ok} ToDo, {fail} неуспешни",
  todo_unknown: "Неизвестно",
  todo_created_from_message: "Задачата е създадена от това съобщение",
  kjuup_io_todo_calendar_trial_ended_note: "Синхронизация на календар · Абонирайте се",
  kjuup_io_todo_calendar_nudge: "Да се синхронизира ли това ToDo с вашия календар?",
  kjuup_io_todo_calendar_nudge_cta: "Активирай Kjuup.io",
  todo_confirmed: "ToDo потвърдено",
  pro_todo_bulk_delete_title: "Да се изтрият ли {{n}} задачи?",
  pro_todo_previous_none_own: "Просрочените задачи са ви възложени от други и само те могат да ги изтрият.",
  pro_todo_previous_none: "Няма просрочени задачи",
  pro_todo_previous_title: "Да се изтрият ли {{n}} просрочени задачи?",
  pro_todo_previous_text: "Всички ваши отворени задачи от предишни дни ще бъдат изтрити.",
  pro_todo_previous_skipped: "Задачите, възложени ви от други, остават: {{n}}.",
  unassign_task_confirm: "Искате ли да отмените възлагането си за тази задача?",
  unassign_label: "Отмени",
  pro_todo_delete_title: "Изтриване на задачата",
  pro_todo_today: "Днес",
  pro_todo_yesterday: "Вчера",
  pro_todo_since_yesterday: "От вчера",
  pro_todo_mark_open: "Маркирай като отворена",
  verify_completion: "Потвърди",
  new_label: "Ново",
  bookmarked_no_mylist: "Отбелязаните задачи не могат да се добавят към Моят списък",
  delete_only_own: "Можете да изтривате само задачи, които сте създали",
  todo_clear_all: "Изчисти всичко",
  pro_todo_of_completed: "{{done}} от {{total}} изпълнени",
  pro_todo_pick_date: "Изберете дата",
  pro_todo_show_day: "Покажи деня",
  todo_adjust_list: "Настрой списъка",
  pro_todo_section_upcoming: "Предстоящи",
  pro_todo_section_done: "Завършени",
  pro_todo_room_empty_today: "Днес няма задачи в този проект",
  pro_todo_room_empty_day: "Няма задачи в този ден в този проект",
  pro_todo_delete_previous: "Изтрий всички",
  todo_my_list_empty: "Денят ти е празен",
  todo_my_list_empty_hint: "Кликнете „Промяна на списъка“, за да добавите задачи",
  pro_todo_empty_title: "Тук няма нищо",
  pro_todo_empty_hint: "Няма задачи, съответстващи на този изглед.",
  pro_todo_selected: "Избрани: {{n}}",
  delete_selected_count: "Изтриване ({count})",
  pro_todo_adjust_done: "Готово",
  pro_todo_deleting: "Изтриване...",
  pro_todo_reopen: "Отвори задачата отново",
  pro_todo_step_done: "Изпълнено",
  move_back_in_progress: "Върни в процес",
  pro_todo_mark_not_started: "Маркирай като незапочната",
  back_into_in_progress: "Обратно в процес",
  pro_todo_mark_in_progress: "Маркирай като в процес",
  unassign_todo: "Отмени възлагане на ToDo",
  pro_todo_open_room: "Отвори проекта",
  pro_todo_new_task: "Нова задача",
  select_user_back_to_in_progress: "Изберете потребител, който да се върне в процес",
  cockpit_email_accounts_n_many: "Свързани акаунти: {{n}}",
  // Kjuup + Microsoft Teams chats (new-chat pickers, combined groups)
  combined_tab_kjuup: "Контакти в Kjuup",
  combined_tab_teams: "Контакти в Teams",
  combined_bridge_failed: "Копието в Teams не можа да бъде създадено.",
  combined_chat_label: "Kjuup + Teams",
  combined_guest_tag: "Teams",
  combined_new_group_note: "Контакти в Kjuup и Teams: създава се нова група, която се появява и в Microsoft Teams.",
  teams_new_chat_title: "Нов чат в Teams",
  teams_new_chat_topic: "Име на групата (по избор)",
  teams_new_chat_start: "Започни чат",
  teams_new_chat_creating: "Създаване на чат…",
  teams_new_chat_forbidden: "Microsoft Teams не позволява този чат (напр. човек извън организацията ви или правило на ИТ отдела).",
  teams_new_chat_too_many: "Твърде много хора за един чат.",
  teams_new_chat_type_hint: "Въведете име, за да търсите в организацията си.",
  teams_new_chat_directory_forbidden: "Организацията ви не позволява търсене в директорията. Показват се само хора от чатовете ви в Teams.",
  teams_new_chat_account: "Акаунт",
};
